module.exports = __webpack_public_path__ + "static/media/435_Bathroom.636c6127.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Bathroom.jpg
// module id = 551
// module chunks = 0